import { animate, timeline, stagger } from "motion";

const sharedAnimationSettings = {
  opacity: [0, 1],
  y: [20, 0],
  x: [10, 0],
};

const sharedTimingSettings = {
  duration: 0.3,
  ease: "ease-out",
};

const progressBarSequence = [
  [
    '.progress-heading', { ...sharedAnimationSettings }, { ...sharedTimingSettings, delay: 0.5, }
  ],
  [
    '.progress', { opacity: [0, 1], scaleX: [0, 1] }, { ...sharedTimingSettings, delay: stagger(0.3), duration: 0.5 }
  ],
  [
    '.dot', { ...sharedAnimationSettings, y: [0, 0], x: [0, 0], scaleX: [0, 1], scaleY: [0, 1] }, { ...sharedTimingSettings, delay: stagger(0.3), duration: 0.5 }
  ],
  [
    '.text-wrap', { ...sharedAnimationSettings, y: [0, 0], x: [0, 0], scaleX: [1.5, 1], scaleY: [1.5, 1] }, { ...sharedTimingSettings, delay: stagger(0.3), duration: 0.5, at: '<' }
  ]
];

const pageSequence = [
  [
    ".page-top .page-title",
    sharedAnimationSettings,
    { ...sharedTimingSettings },
  ],
  [
    ".page-top .page-intro",
    { ...sharedAnimationSettings, x: [-10, 0] },
    { ...sharedTimingSettings },
  ],
  [
    ".page-top .page-tier",
    { ...sharedAnimationSettings, x: [0, 0], y: [-20, 0], scale: [1.2, 1] },
    { ...sharedTimingSettings, delay: 0.3, duration: 0.4 },
  ],
  [
    '.nav-tabs li', { ...sharedAnimationSettings, x: [0, 0] }, { ...sharedTimingSettings, delay: stagger(0.1), duration: 0.2 }
  ],
  [
    '.dashboard-item', { ...sharedAnimationSettings, y: [-10, 0], x: [0, 0], scale: [0.9, 1] }, { ...sharedTimingSettings, duration: 0.1, at: "<" }
  ],
  [
    '.progress-card', sharedAnimationSettings, {...sharedTimingSettings, delay: stagger(0.2), at: '<'}
  ],
];



export const progressBarTimeline = () => {
  timeline(progressBarSequence);
};

export const pageTimeline = () => {
  timeline(pageSequence);
};

export const profileAnimation = () => {
  animate('.profile-group', sharedAnimationSettings, { ...sharedTimingSettings, delay: stagger(0.1) });
};

